import FEATURE_FLAGS from "@flags";

const baseTabs = [
  {
    key: "dashboard",
    label: "Dashboard",
  },
  {
    key: "leadership-rank",
    label: "Leadership Rank",
  },
  {
    key: "sales-rank",
    label: "Sales Rank",
  },
  {
    key: "earnings-intelligence",
    label: "Earnings Intelligence",
  },
  {
    key: "ledger",
    label: "Ledger",
  },
];

const commonTabs = FEATURE_FLAGS.includes("rankBreakdown")
  ? [...baseTabs, { key: "rank-breakdown", label: "Rank Breakdown" }]
  : baseTabs;

const adminTabs = [];

export { commonTabs, adminTabs };

export default [...commonTabs, ...adminTabs];
